import { useMemo, useEffect, useState } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import { useTranslation } from 'react-i18next';
import { Divider } from "@mui/material";
import Utility from "../utility/utility";

function HCViewAspect({ tableData, title }) {
    const { t } = useTranslation();
    const dataTableData = {
        columns: [
          {
                Header: t(""), accessor: "planet", width: "5%", Cell: ({ cell }) =>
                    <p dangerouslySetInnerHTML={{ __html: `${Utility.getPlanetSymbol(cell.row.original.planet)}` }} />

            },
            {
                Header: t("PLANET"), accessor: "", Cell: ({ cell }) =>
                    <p>{cell.row.original.planet} </p>

            },
          { Header: t("ThenpathRashiya"), accessor: "rasi" },
          { Header: t("AspectedRashi"), accessor: "aspectedRasis" },
          { Header: t("AspectedBhava"), accessor: "aspectedHouses" },
          { Header: t("AspectedPlanet"), accessor: "aspectedPlanets" },
        ],
        rows:tableData
    }

    return (
            <MDBox pt={0} pb={1}>
                <MDBox mb={1}>
                    <Card>
                        {/* <MDBox p={3} lineHeight={1} mb={0} display="flex" alignItems="center">
                            <MDTypography variant="h5" fontWeight="medium">
                            { title }
                            </MDTypography>
                        <Divider  variant="fullWidth" sx={{ flexGrow: 1, marginLeft: 2 }} />
                        </MDBox> */}
                        <DataTable 
                        canSearch={false} 
                        entriesPerPage={false}
                        showTotalEntries={false}
                        table={dataTableData} />
                    </Card>
                </MDBox>
            </MDBox>
    );
};

HCViewAspect.propTypes = {
    tableData: PropTypes.array,
    title : PropTypes.string,
    cell: PropTypes.shape({
    row: PropTypes.shape({
        getToggleRowExpandedProps: PropTypes.func.isRequired,
        isExpanded: PropTypes.bool.isRequired,
        subRows: PropTypes.array,
        values: PropTypes.any,
        dasaLevel: PropTypes.number,
        original: PropTypes.shape({
            planet: PropTypes.string.isRequired
        })
    }),
    }),
  };

export default HCViewAspect;